import { render, staticRenderFns } from "./makerInfo.vue?vue&type=template&id=4c8c475e&scoped=true"
import script from "./makerInfo.vue?vue&type=script&lang=js"
export * from "./makerInfo.vue?vue&type=script&lang=js"
import style0 from "./makerInfo.vue?vue&type=style&index=0&id=4c8c475e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8c475e",
  null
  
)

export default component.exports